import type { SupportTicketId } from "@redotech/effect-api-shared/ids/definitions";
import type { ChannelThread } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { ChatThreadView } from "./chat-thread-view";

interface SmsThreadViewProps {
  supportTicketId: SupportTicketId;
  thread: ChannelThread;
}

export const SmsThreadView = memo(function SmsThreadView({
  supportTicketId,
  thread,
}: SmsThreadViewProps) {
  return (
    <ChatThreadView
      channel="sms"
      supportTicketId={supportTicketId}
      thread={thread}
    />
  );
});
